import styled, { css } from 'styled-components'

export const Container = styled.div<{ $collapsed?: boolean }>`
	background-color: ${(props) =>
		props.$collapsed
			? props.theme.colors.layout.treePanel.headerBackgroundColor
			: props.theme.colors.layout.treePanel.backgroundColor};
	flex-grow: 1;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	min-width: 0;
	transition: width 0.2s ease, min-width 0.2s ease, background-color 0.2s ease;

	${(props) =>
		props.$collapsed &&
		css`
			width: 40px;
			min-width: 40px;
			max-width: 40px;
			flex-shrink: 0;
		`}
`

export const TreeContainer = styled.div`
	color: #333;
	flex-grow: 1;
	overflow: auto;
	min-width: 0;

	.simplebar-placeholder {
		display: none;
	}
`

export const SearchContainer = styled.div`
	display: flex;
	border-bottom: 1px solid #ddd;

	input[type='text'] {
		border: 0;
		padding-left: 10px;
	}
`
